import { useState, useCallback } from 'react';
import { useValueHighlighter } from './useValueHighlighter';

export const useSetupValue = ({ currentConversion, updateDraftEvent }) => {
    const [includeValue, setIncludeValue] = useState(true);
    const [isHighlighting, setIsHighlighting] = useState(false);
    const [selectedValue, setSelectedValue] = useState(undefined);

    const handleRadioChange = useCallback(
        value => {
            const shouldIncludeValue = value === 'select';
            setIncludeValue(shouldIncludeValue);
            if (!shouldIncludeValue) {
                updateDraftEvent(draft => ({
                    ...draft,
                    trackedElements: [
                        {
                            ...(draft.trackedElements?.[0] || {}),
                            valueSelector: undefined,
                        },
                    ],
                }));
            }
            setSelectedValue(undefined);
        },
        [updateDraftEvent]
    );

    const handleValueSelect = useCallback(
        ({ path, value }) => {
            setSelectedValue(value);
            updateDraftEvent(draft => ({
                ...draft,
                trackedElements: [
                    {
                        ...(draft.trackedElements?.[0] || {}),
                        valueSelector: path,
                    },
                ],
            }));

            setIsHighlighting(false);
        },
        [updateDraftEvent]
    );

    useValueHighlighter({
        isHighlighting,
        onValueClick: handleValueSelect,
    });

    const handleEditValue = useCallback(() => {
        setIsHighlighting(true);
        setSelectedValue(undefined);
    }, []);

    const valueSelectorFromConversion = currentConversion?.trackedElements?.[0]?.valueSelector;
    const canCreateEvent = includeValue ? !!valueSelectorFromConversion : true;

    return {
        includeValue,
        isHighlighting,
        selectedValue,
        canCreateEvent,
        handleRadioChange,
        handleEditValue,
        setIsHighlighting,
    };
};
